if (!customElements.get('products-grid-carousel')) {
  class ProductsGridCarousel extends HTMLElement {
    connectedCallback() {
      if (!window.matchMedia('(max-width: 767px)').matches) return;
      if (this.dataset.enableCarousel !== 'true') return;

      this.slider = new Splide(this, {
        type: 'slider',
        perPage: 2,
        gap: 12,
        padding: { left: 20, right: '21%' },
        arrows: false,
        pagination: true,
        drag: true,
      }).mount();
    }
  }
  customElements.define('products-grid-carousel', ProductsGridCarousel);
}
